import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import style from './style.module.less'
import Panel from '../Panel'
import LabelText from '../LabelText'

class EditCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expend: false
    }
  }

  render() {
    const { expend } = this.state
    const { item, operator } = this.props
    const { merchant_customer_info = {}, demand_info = [] } =
      item.modify_card || {}
    const {
      user_wechat,
      user_phone,
      user_name,
      gender,
      weddingday,
      mate_name,
      mate_phone,
      mate_wechat,
      shop_area
    } = merchant_customer_info
    let totalNum = demand_info.filter(demand => !isEmpty(demand.diff.remark))
      .length
    map(merchant_customer_info.modify_card, item => {
      if (!isEmpty(item)) {
        totalNum++
      }
    })
    return (
      <Panel
        item={item}
        icon="//qnm.hunliji.com/o_1d8n7hgtfqs112121cjkri61f75e.png"
      >
        <div
          style={
            !expend && totalNum >= 4
              ? { height: '130px', overflow: 'hidden' }
              : {}
          }
        >
          {!isEmpty(user_phone) && (
            <div className={style.item}>
              <span>手机号&nbsp;:&nbsp;</span>
              <span className={style.del}>{user_phone.old_val || '空'}</span>
              <span>{user_phone.new_val || '空'}</span>
            </div>
          )}
          {!isEmpty(user_name) && (
            <div className={style.item}>
              <span>姓名&nbsp;:&nbsp;</span>
              <span className={style.del}>{user_name.old_val || '空'}</span>
              <span>{user_name.new_val || '空'}</span>
            </div>
          )}
          {!isEmpty(gender) && (
            <div className={style.item}>
              <span>性别&nbsp;:&nbsp;</span>
              <span className={style.del}>{gender.old_val || '空'}</span>
              <span>{gender.new_val || '空'}</span>
            </div>
          )}
          {!isEmpty(user_wechat) && (
            <div className={style.item}>
              <span>微信号&nbsp;:&nbsp;</span>
              <span className={style.del}>{user_wechat.old_val || '空'}</span>
              <span>{user_wechat.new_val || '空'}</span>
            </div>
          )}
          {!isEmpty(weddingday) && (
            <div className={style.item}>
              <span>婚期&nbsp;:&nbsp;</span>
              <span className={style.del}>{weddingday.old_val || '空'}</span>
              <span>{weddingday.new_val || '空'}</span>
            </div>
          )}
          {!isEmpty(mate_name) && (
            <div className={style.item}>
              <span>伴侣姓名&nbsp;:&nbsp;</span>
              <span className={style.del}>{mate_name.old_val || '空'}</span>
              <span>{mate_name.new_val || '空'}</span>
            </div>
          )}
          {!isEmpty(mate_phone) && (
            <div className={style.item}>
              <span>伴侣手机号&nbsp;:&nbsp;</span>
              <span className={style.del}>{mate_phone.old_val || '空'}</span>
              <span>{mate_phone.new_val || '空'}</span>
            </div>
          )}
          {!isEmpty(mate_wechat) && (
            <div className={style.item}>
              <span>伴侣微信号&nbsp;:&nbsp;</span>
              <span className={style.del}>{mate_wechat.old_val || '空'}</span>
              <span>{mate_wechat.new_val || '空'}</span>
            </div>
          )}
          {!isEmpty(shop_area) && (
            <div className={style.item}>
              <span>城市&nbsp;:&nbsp;</span>
              <span className={style.del}>{shop_area.old_val || '空'}</span>
              <span>{shop_area.new_val || '空'}</span>
            </div>
          )}
          {demand_info.map((demand, index) => {
            if (isEmpty(demand.diff.remark)) {
              return null
            }
            return (
              <div className={style.item} key={index}>
                <span>{demand.property_name}&nbsp;:&nbsp;</span>
                <div className={style['edit-div']}>
                  <p>{demand.diff.remark.old_val || '空'}</p>
                  <p>{demand.diff.remark.new_val || '空'}</p>
                </div>
              </div>
            )
          })}
        </div>
        {totalNum >= 4 && (
          <div
            className={style.expend}
            onClick={() => this.setState({ expend: !expend })}
          >
            {expend ? '隐藏' : '展开'}
          </div>
        )}

        <LabelText label="操作人">{operator}</LabelText>
      </Panel>
    )
  }
}

export default EditCard
